import type { ReactNode } from "react";

/** En tast i en snarvei-hint, f.eks. <Kbd>⌘</Kbd><Kbd>K</Kbd>. */
export const Kbd = ({ children }: { children: ReactNode }) => (
  <kbd className="inline-flex h-5 min-w-5 items-center justify-center rounded border bg-muted px-1 font-sans text-[11px] font-medium text-muted-foreground">
    {children}
  </kbd>
);
